/* global FB */
import { useEffect } from 'react';
import MainLayout from '../components/MainLayout/MainLayout';
// import MainLayout from './MainLayout'; // Assuming MainLayout is a layout component

const TestingIntegration = () => {
  
  // Function to handle status changes based on Facebook login status
  const statusChangeCallback = (response) => {
    console.log('Facebook login status changed: ', response);

    if (response.status === 'connected') {
      // The user is logged into both Facebook and your app
      const { accessToken, userID } = response.authResponse;
      console.log('User is logged in:', { accessToken, userID });
      // Here, you could trigger additional logic, such as redirecting the user
    } else if (response.status === 'not_authorized') {
      // The user is logged into Facebook but not into your app
      console.log('User is logged into Facebook but not authorized for the app.');
      promptLogin(); // Prompt them to log into the app
    } else {
      // The user is not logged into Facebook
      console.log('User is not logged into Facebook.');
      promptLogin(); // Optionally prompt the login dialog
    }
  };

  // Function to prompt Facebook Login Dialog
  const promptLogin = () => {
    FB.login((response) => {
      if (response.authResponse) {
        // User successfully logs in
        console.log('User logged in successfully.');
        statusChangeCallback(response);
      } else {
        console.log('User cancelled login or did not fully authorize.');
      }
    });
  };

  useEffect(() => {
    // Initialize Facebook SDK
    window.fbAsyncInit = function () {
      FB.init({
        appId: '535705179174094',  // Replace with your actual App ID
        cookie: true,
        xfbml: true,
        version: 'v21.0', // Replace with the correct API version
        response_type:'code' 
      });

      // Check login status upon loading the page
      FB.getLoginStatus(function (response) {
        statusChangeCallback(response);
      });
    };

    // Load the Facebook SDK script asynchronously
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }, []);

  return (
    <MainLayout>
      <h1>Facebook SDK Integration</h1>
      <p>Checking Facebook Login Status...</p>
      <div id="facebook-jssdk"></div>
      {/* Button to trigger Facebook login dialog */}
      <button onClick={promptLogin}>Login with Facebook</button>
    </MainLayout>
  );
};

export default TestingIntegration;
